import { Injectable, Provider } from '@angular/core';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { ILocalStorageServiceToken } from './localstorage-service.interface';

@Injectable({
  providedIn: null
})
export class LocalStorageService implements LocalStorageService {
  private accessTokenName: string;
  private cookieTermsName: string;
  private ageVerificationName: string;

  public constructor() {
    this.accessTokenName = ENVIRONMENT.browserStorage.accessTokenName;
    this.cookieTermsName = ENVIRONMENT.browserStorage.cookieTermsName;
    this.ageVerificationName = ENVIRONMENT.browserStorage.ageVerificationName;
  }

  public accessJWTGet(): string {
    return this.getItem(this.accessTokenName);
  }

  public accessJWTSet(value: string): string {
    this.setItem(this.accessTokenName, value);
    return this.accessJWTGet();
  }

  public accessJWTClear(): void {
    this.removeItem(this.accessTokenName);
  }

  public cookieTermsAcceptanceStateGet(): boolean {
    let cookieTermsValue = this.getItem(this.cookieTermsName);
    if (cookieTermsValue == undefined) {
      return false;
    }
    if (cookieTermsValue === 'yes') {
      return true;
    }
    return false;
  }

  public cookieTermsAcceptanceStateSet(value: string): boolean {
    this.setItem(this.cookieTermsName, value);
    return this.cookieTermsAcceptanceStateGet();
  }

  public cookieTermsAcceptanceStateClear(): void {
    this.removeItem(this.cookieTermsName);
  }

  public ageVerificationAcceptanceGet(): boolean {
    let ageVerificationValue = this.getItem(this.ageVerificationName);
    if (ageVerificationValue == undefined) {
      return false;
    }
    if (ageVerificationValue === 'yes') {
      return true;
    }
    return false;
  }

  public ageVerificationAcceptanceSet(value: string): boolean {
    this.setItem(this.ageVerificationName, value);
    return this.cookieTermsAcceptanceStateGet();
  }

  public ageVerificationAcceptanceClear(): void {
    this.removeItem(this.ageVerificationName);
  }

  public getItem(key: string): string {
    let entry: string | null = localStorage.getItem(key);
    return entry ? entry : "";
  }

  public setItem(key: string, value: string): string {
    localStorage.setItem(key, value);
    return this.getItem(key);
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const LocalStorageServiceProvider: Provider[] = [
  { provide: ILocalStorageServiceToken, useClass: LocalStorageService }
];
